module.exports = __webpack_public_path__ + "media/images/download/service_doc-0da355bd53a7a35e4c54fbae211e5425.png";